import {
  JourneyChannelScheduleStatus,
  JourneyDerivedStatus,
} from "../types/journey";

/**
 * Maps between different status representations for journey and channel schedules
 * This centralizes the display logic for consistent UI
 */

// Map channel status to a standardized display value
export const mapChannelStatusToDisplay = (
  status: JourneyChannelScheduleStatus,
): string => {
  const statusMap: Record<JourneyChannelScheduleStatus, string> = {
    published: "Scheduled",
    in_progress: "Live",
    completed: "Completed",
  };
  return statusMap[status] || status;
};

// Map journey status to a standardized display value (for consistency)
export const mapJourneyStatusToDisplay = (
  status: JourneyDerivedStatus,
): string => {
  const statusMap: Record<JourneyDerivedStatus, string> = {
    DRAFT: "Draft",
    SCHEDULED: "Scheduled",
    LIVE: "Live",
    COMPLETED: "Completed",
  };
  return statusMap[status] || status;
};

// Get appropriate style classes for a status badge
export const getStatusBadgeClasses = (
  displayStatus: string,
): { bg: string; text: string } => {
  switch (displayStatus) {
    case "Draft":
      return { bg: "bg-gray-100", text: "text-gray-800" };
    case "Scheduled":
      return { bg: "bg-blue-100", text: "text-blue-800" };
    case "Live":
      return { bg: "bg-green-100", text: "text-green-800" };
    case "Completed":
      return { bg: "bg-indigo-100", text: "text-indigo-800" };
    default:
      return { bg: "bg-gray-100", text: "text-gray-800" };
  }
};

// For converting between journey and channel status (useful for new features)
export const journeyStatusToChannelStatus = (
  journeyStatus: JourneyDerivedStatus,
): JourneyChannelScheduleStatus => {
  switch (journeyStatus) {
    case "SCHEDULED":
      return "published";
    case "LIVE":
      return "in_progress";
    case "COMPLETED":
      return "completed";
    default:
      return "published"; // Default case
  }
};
